import { object } from '@/core/utils/validation';
import { blockedItemSchema, pickingItemSchema, taskSchema } from './SocketMessageBase.yup';
const blockedOnPickingMessageSchema = object({
    task: taskSchema.required(),
    pickingItem: pickingItemSchema.required(),
    blockedItem: blockedItemSchema.required(),
}).noUnknown(true);
export { blockedOnPickingMessageSchema };
